import { TrendingUp, TrendingDown, ChevronRight } from "lucide-react";

export default function PickCard({ pick, rank, onSelect }) {
  const isLong = pick.direction === "LONG";
  return (
    <div
      className="border border-white/10 bg-[#121215] p-5 hover:border-white/30 transition-colors cursor-pointer flex flex-col gap-3 group"
      onClick={() => onSelect && onSelect(pick.symbol)}
      data-testid={`pick-card-${pick.symbol}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="font-mono text-xs text-zinc-500">#{rank}</span>
          <span className="font-display font-black text-2xl tracking-tighter text-white">
            {pick.symbol}
          </span>
        </div>
        <span
          className={`flex items-center gap-1 font-mono text-[10px] tracking-wider px-2 py-1 border ${
            isLong
              ? "border-green-500/40 text-green-400 bg-green-500/5"
              : "border-red-500/40 text-red-400 bg-red-500/5"
          }`}
        >
          {isLong ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
          {pick.direction}
        </span>
      </div>

      <div className="grid grid-cols-4 gap-2 text-center">
        <div className="border-r border-white/5 pr-2">
          <div className="font-mono text-[9px] tracking-[0.2em] text-zinc-500 uppercase">Conv</div>
          <div className="font-mono text-lg font-bold text-white tabular-nums">
            {pick.avg_conviction.toFixed(1)}
          </div>
        </div>
        <div className="border-r border-white/5 pr-2">
          <div className="font-mono text-[9px] tracking-[0.2em] text-zinc-500 uppercase">Entry</div>
          <div className="font-mono text-sm text-white tabular-nums">
            ${pick.avg_entry?.toFixed(2)}
          </div>
        </div>
        <div className="border-r border-white/5 pr-2">
          <div className="font-mono text-[9px] tracking-[0.2em] text-zinc-500 uppercase">Tgt</div>
          <div className="font-mono text-sm text-green-400 tabular-nums">
            ${pick.avg_target?.toFixed(2)}
          </div>
        </div>
        <div>
          <div className="font-mono text-[9px] tracking-[0.2em] text-zinc-500 uppercase">Stop</div>
          <div className="font-mono text-sm text-red-400 tabular-nums">
            ${pick.avg_stop?.toFixed(2)}
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between text-xs text-zinc-400">
        <span className="font-mono">
          {pick.voter_count}/3 models · {pick.horizon}
        </span>
        <span className="font-mono text-zinc-500 group-hover:text-white flex items-center gap-1 transition-colors">
          Drill in <ChevronRight className="w-3 h-3" />
        </span>
      </div>

      {pick.rationales?.[0]?.text && (
        <p className="text-xs text-zinc-400 leading-relaxed border-t border-white/5 pt-3">
          <span className="font-mono text-[9px] tracking-[0.2em] text-zinc-500 uppercase mr-2">
            {pick.rationales[0].by}
          </span>
          {pick.rationales[0].text}
        </p>
      )}
    </div>
  );
}
